import React, { useState } from 'react';
import { faqs } from '../data/faqData';
import { Plus, X } from 'lucide-react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="bg-white py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-[1fr_1.6fr] gap-8 lg:gap-16 items-start">

          {/* Left — header + CTA */}
          <div className="lg:sticky lg:top-24">
            <p className="text-xs font-semibold tracking-[0.12em] uppercase text-[#970000] mb-3">
              FAQ
            </p>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-[-0.04em] leading-[1.1] text-gray-900">
              Häufig gestellte{' '}
              <span className="oblique font-extrabold text-[#970000]">Fragen</span>
            </h2>
            <p className="mt-3 md:mt-4 text-[15px] leading-relaxed text-gray-500">
              Alles Wichtige rund um Ablauf, Kurse und Teilnahme.
            </p>

            {/* CTA box — red with white button */}
            <div className="mt-6 md:mt-8 relative overflow-hidden rounded-2xl bg-[#b30000] p-5 md:p-6 text-white">
              <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-white/15 via-transparent to-black/15" />
              <div className="relative">
                <p className="text-[13px] font-semibold text-white/60 mb-2">Noch eine Frage?</p>
                <p className="text-[15px] font-semibold text-white mb-5">
                  Schreib uns direkt — wir helfen gerne.
                </p>
                <a
                  href="#contact"
                  className="inline-flex items-center justify-center rounded-full bg-white px-5 py-2.5 text-[13px] font-semibold text-[#970000] hover:bg-gray-100 transition-colors shadow-sm"
                >
                  Kontakt aufnehmen
                </a>
              </div>
            </div>
          </div>

          {/* Right — FAQ list */}
          <div className="space-y-2">
            {faqs.map((faq, index) => {
              const isOpen = openIndex === index;
              return (
                <div key={index} className={`rounded-2xl border overflow-hidden transition-colors duration-200 ${isOpen ? 'border-gray-200 bg-white' : 'border-gray-100 bg-white'}`}>
                  <button
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left hover:bg-gray-50/60 transition-colors"
                  >
                    <span className={`text-[15px] font-bold leading-snug tracking-[-0.01em] transition-colors duration-200 ${isOpen ? 'text-[#970000]' : 'text-[#1a0606]'}`}>
                      {faq.question}
                    </span>
                    <div className={`shrink-0 w-6 h-6 rounded-full flex items-center justify-center transition-colors duration-200 ${
                      isOpen
                        ? 'bg-[#970000] text-white'
                        : 'border border-gray-200 text-gray-400 hover:border-gray-300'
                    }`}>
                      {isOpen ? <X className="h-3 w-3" /> : <Plus className="h-3 w-3" />}
                    </div>
                  </button>
                  <div className={`grid transition-all duration-200 ease-in-out ${isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}>
                    <div className="overflow-hidden">
                      <p className="px-5 pb-5 text-[14px] leading-[1.75] text-gray-500">
                        {faq.answer}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
